import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const PASSWORD_PLACEHOLDER = "3b-password-placeholder";

export const loginCredentials = defineConnector({
  identifier: "loginCredentials",
  name: "Login credentials",
  tagLine: "Username and password authentication",
  logo,
  protocol: "http",
  aiContext: `LOGIN_USERNAME contains the configured username. LOGIN_PASSWORD is always the literal placeholder ${PASSWORD_PLACEHOLDER}, never the real password. Use it unchanged where the password belongs in an outbound HTTP request to an allowed URL; the proxy substitutes the real password in the URL, headers, or text body. Its value, length, and hash do not change when the saved password changes. This connector cannot supply a real password to a CLI or SDK that hashes, encrypts, or otherwise transforms it locally before sending the request.`,
  tags: ["custom"],
  defaultUrlPattern: () => ".*",
  customizeStepHandledInline: true,
  auth: customAuth("loginCredentials", {
    placeholder: PASSWORD_PLACEHOLDER,
  }),
  steps: [
    {
      title: "Configure your login credentials",
      items: [
        {
          kind: "input",
          label: "Name",
          placeholder: "My login credentials",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "url-pattern",
          placeholder: "api.example.com",
          target: { kind: "connectedApp", field: "urlPattern" },
        },
        {
          kind: "input",
          label: "Username",
          placeholder: "user@example.com",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          placeholder: "••••••••",
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "url",
          label: "Test URL (optional)",
          placeholder: "https://api.example.com/user",
          helperText:
            "URL to test the connection. Leave blank to skip testing.",
          target: { kind: "configuration", field: "testUrl" },
        },
      ],
    },
  ],
  connectionTest: { protocol: "http", request: ({ testUrl }) => `${testUrl}` },
  publicEnvVars: ({ username }) => ({
    LOGIN_USERNAME: username ?? "",
    LOGIN_PASSWORD: PASSWORD_PLACEHOLDER,
  }),
});
